import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchPortalPolicy, savePortalPolicy, removePortalPolicy } from "../api/integrations";

// Admin-only read: the caller gates on role, and the flag keeps a
// non-admin mount from ever issuing the request.
export function usePortalPolicy(enabled: boolean) {
  return useQuery({
    queryKey: ["integrations", "portal"],
    queryFn: fetchPortalPolicy,
    staleTime: 60_000,
    enabled,
  });
}

// The status row quotes the policy, so both refresh together.
function usePortalInvalidation() {
  const queryClient = useQueryClient();
  return async () => {
    await Promise.all([
      queryClient.invalidateQueries({ queryKey: ["integrations", "portal"] }),
      queryClient.invalidateQueries({ queryKey: ["integrations", "status"] }),
    ]);
  };
}

// One mutation key for every write, so the dialog holding the form can
// ask "is a call in flight?" without owning the mutations.
const PORTAL_WRITE = ["integrations", "portal"];

export function useSavePortalPolicy() {
  const invalidate = usePortalInvalidation();
  return useMutation({
    mutationKey: PORTAL_WRITE,
    mutationFn: savePortalPolicy,
    onSuccess: invalidate,
  });
}

export function useRemovePortalPolicy() {
  const invalidate = usePortalInvalidation();
  return useMutation({
    mutationKey: PORTAL_WRITE,
    mutationFn: removePortalPolicy,
    onSuccess: invalidate,
  });
}
